var $c64f4db9c44aed5b$exports = {};
$c64f4db9c44aed5b$exports = {
  "collapse": "R\xE9duire",
  "expand": "D\xE9velopper"
};
export { $c64f4db9c44aed5b$exports as default };